import React, { useRef } from 'react';

const SlideToggle = ({ value, onChange, fontSize, additionalClasses, children }) => {
  const elementRef = useRef(null);
  const handleClick = () => {
    onChange?.(!value);
    elementRef.current?.blur();
  };

  return (
    <label ref={elementRef} className={`inline-flex cursor-pointer items-center ${additionalClasses}`}>
      <input type="checkbox" checked={value} className="peer sr-only" onChange={handleClick} />
      <div className="peer dark:border-pddarkblue peer-checked:bg-pddarkblue dark:peer-checked:bg-pddarkblue relative h-7 w-14 rounded-full bg-gray-200 peer-focus:outline-none after:absolute after:start-[0.25px] after:top-[-0.5px] after:h-7.5 after:w-7.5 after:rounded-full after:border after:border-gray-400 after:bg-white after:transition-all peer-checked:after:translate-x-[18px] peer-checked:after:border-gray-400 rtl:peer-checked:after:-translate-x-full dark:bg-gray-300"></div>
      <span className={`${fontSize} ms-5 font-normal text-black`}>{children}</span>
    </label>
  );
};

export default SlideToggle;
